import { Field, useFormikContext } from "formik";
import { useRef, useState, forwardRef, ForwardedRef, ReactNode, useEffect } from "react";

interface RadioOption {
    id: string;
    value: string;
    label: string;
}

interface RadioGroupProps {
    name: string;
    options: RadioOption[];
    maxLength?: number;
    currentText?: string;
    label?: ReactNode;
    secondary?: boolean;
    defaultChecked?: string;
}

const RadioGroup = forwardRef(
    (
        { name, options, label, secondary,  defaultChecked }: RadioGroupProps,
        ref: ForwardedRef<HTMLTextAreaElement>
    ) => {
        const { setFieldValue, values, errors, touched } = useFormikContext<any>();
        
        useEffect(() => {
            if (!values[name] && defaultChecked) {
                setFieldValue(name, defaultChecked);
            }
        }, [values, name, defaultChecked, setFieldValue]);

        const textAreaRef = useRef<HTMLTextAreaElement>(null);

        const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
            const value = event.target.value;
        };

        return (
            <div>
                {label && <div className="radio-group-label">{label}</div>}
                <div
                    role="radiogroup"
                    aria-labelledby={`${name}-label`}
                    className={`radio-group ${secondary ? "secondary" : "" }`}

                    
                >

                    {errors[name] && touched[name] && (
                        <span
                            aria-describedby={`${name}-error`}
                            className="validation-error"
                        >
                            {errors[name]?.toString() || ""}
                        </span>
                    )}
                    
                    {options.map((option) => (
                        <div
                            key={option.id}
                            className={`radio-item ${errors[name] ? "has-error" : "" }`}
                        >
                            <Field
                                id={option.id}
                                type="radio"
                                name={name}
                                value={option.value}
                                checked={values[name] === option.value}
                                
                            />
                            <label htmlFor={option.id}>{option.label}</label>
                        </div>
                    ))}

                </div>
            </div>
        );
    }
);

export default RadioGroup;
